import KeenSlider from "keen-slider"
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

class SocialShareLinks extends HTMLElement {

	constructor() {
        super();
		this.addEventListener("click", SocialShareLinks.onShareClicked);
	}

	static shareWindow( url, title, w = 500, h = 700 ) {
        if (!window || !window.top) return;

        var y = window.top.outerHeight / 2 + (window.top.screenY - h / 2);
        var x = window.top.outerWidth / 2 + (window.top.screenX - w / 2);

        typeof window !== "undefined" &&
            window.open( url, title, `toolbar=no , location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y} , left=${x}`, );
    }

	static onShareClicked(e) {
        if (!e.target) return;

        const _title = encodeURIComponent(this.getAttribute('data-title'));

        const _pageUrl = encodeURIComponent(location.href);

        const $button = (e.target).closest("a");
        if (!$button) return;
        const _type = $button.getAttribute("data-type");

        switch (_type) {
            case "fb":
                SocialShareLinks.shareWindow( `https://www.facebook.com/sharer/sharer.php?u=${_pageUrl}`, "");
                break;
            case "x":
			case "tw":
                SocialShareLinks.shareWindow(`https://twitter.com/intent/tweet?text=${_title} ${_pageUrl}`, "");
                break;
            case "li":
                SocialShareLinks.shareWindow(`https://www.linkedin.com/sharing/share-offsite/?url=${_pageUrl}`, "");
				break;
			case "redit":
				SocialShareLinks.shareWindow(`http://www.reddit.com/submit?url=${_pageUrl}&title=${_title}`, "");
				break;
			case "telegram":
				SocialShareLinks.shareWindow(`https://telegram.me/share/url?url=${_pageUrl}&text=${_title}`, "");
				break;
			case "whatsup":
				SocialShareLinks.shareWindow(`https://api.whatsapp.com/send?text=${_title}%20${_pageUrl}`, "");
				break;
				
			case "mobile":
				navigator.share({ title: _title, url: location.href });
                break;
        }
    }

	disconnectedCallback() {
		this.removeEventListener("click", SocialShareLinks.onShareClicked);
    }
}

if (!customElements.get("social-share-links"))
	customElements.define("social-share-links", SocialShareLinks);


class ExpandableSection extends HTMLElement {

	$h;
	$p;
	$content;

	constructor() {
        super();
		this.$p = this.querySelector('.cmExpandableSection');
		this.$h = this.querySelector('h2');
		this.$content = this.querySelector('.cmExpandableSectionContent');

		if (this.$h)
			this.$h.addEventListener("click", this.onSectionClicked);
	}

	onSectionClicked = (e) => {
		e.preventDefault();
		
		if (!this.$p)
			return;

		if ( this.$p.classList.contains('open')) {
			this.$p.classList.remove('open');
			this.$content.style.maxHeight = 0;
		} else {
			this.$content.style.maxHeight = this.$content.scrollHeight + "px";
			this.$p.classList.add('open');
		}

		
	}

	disconnectedCallback() {
		if (this.$h)
			this.$h.removeEventListener("click", this.onSectionClicked);
    }
}


if (!customElements.get("cm-expandable-section"))
	customElements.define("cm-expandable-section", ExpandableSection);


class InPostGallery extends HTMLElement {

	slider = null;
	$keenSlider = null;
	$btnLeft = null;
	$btnRight = null;
	$lightBox = null;
	$btnExpand = null;
	tmp = null;

	constructor() {
        super();

		this.$keenSlider = this.querySelector('.keen-slider');

		this.$btnLeft = this.querySelector('.cmGalleryInPostNav.left');
		this.$btnRight = this.querySelector('.cmGalleryInPostNav.right');
		this.$btnExpand = this.querySelector('.cmGalleryEnlarge');

		if (this.$keenSlider) {
			this.init();
		}
	}

	init = () => {

		this.slider = new KeenSlider(
			this.$keenSlider, 
			{
				loop: true,
				slides: {
					perView: 1
				},
				created: (slider) => {
					this.initLightBox();
				},
				slideChanged: (slider) => {
					// const _idx = slider.track.details.rel;
					// this.$lnkArticles.forEach( el => el.classList.remove('active'));
					// this.$lnkArticles[_idx] && this.$lnkArticles[_idx].classList.add('active');

					
				}
			}
		)

		this.$btnLeft?.addEventListener('click', this.movePrev);
		this.$btnRight?.addEventListener('click', this.moveNext);
		this.$btnExpand?.addEventListener('click', this.onSlideClicked);

	}

	onSlideClicked = (e) => {
		e.preventDefault();

		if (this.$lightBox) {
			const _idx  =this.slider.track.details.rel || 0;
			this.$lightBox.loadAndOpen(_idx);
		}
	}

	initLightBox = () => {
		const galleryImages = [];
		this.$keenSlider.querySelectorAll('.keen-slider__slide').forEach( S => {

			const $I = S.querySelector('img');
			const $caption = S.querySelector('figcaption');

			galleryImages.push({
				src: $I.getAttribute('src'),
				width: Number( $I.getAttribute('width') ),
				height: Number( $I.getAttribute('height') ),
				alt: $caption ? $caption.textContent : ''
			});

		})

		if (this.$lightBox) 
			this.$lightBox.destroy();

		this.$lightBox = new PhotoSwipeLightbox({
			dataSource: galleryImages,
			bgOpacity: 0.9,
			pswpModule: () => import('photoswipe'),
		});

		this.$lightBox.on('uiRegister', () => {
			this.$lightBox.pswp.ui.registerElement({
				name: 'photoswipe-caption',
				order: 9,
				isButton: false,
				appendTo: 'root',
				html: '',
				onInit: (el, pswp) => {
					pswp.on('change', () => {
						const currSlideElement = pswp.currSlide.data;
						el.innerHTML = currSlideElement.alt || '';
					});
				}
			});
		});

  		this.$lightBox.init();
	}

	movePrev = () => {
		if (!this.slider)
			return;

		this.slider.prev();
	}

	moveNext = () => {
		if (!this.slider)
			return;

		this.slider.next();
	}

	disconnectedCallback() {

		if (this.slider) {
			this.slider.destroy();
		}

		if (this.$lightBox) {
			this.$lightBox.destroy();
			this.$lightBox = null;
		}
		
		this.$btnLeft?.removeEventListener('click', this.movePrev);
		this.$btnRight?.removeEventListener('click', this.moveNext);
		this.$btnExpand?.removeEventListener('click', this.onSlideClicked);
    }
}

if (!customElements.get("cm-gallery"))
	customElements.define("cm-gallery", InPostGallery);